export const SERVICE_NAMESPACE = 'cta-automation-service';
export const DEEPLINK_MOCK_DATA_STORAGE_KEY = 'cta_service.deeplink_response_mock_data';

export const PROD_API_URL = 'https://api.oneweb.mercedes-benz.com';
